<div class="comments-card" data-testid="comments-card">
  <div class="comments-card__header">
    @if (outstandingCount > 0) {
      <span
        class="pill pill--warning comments-card__outstanding-badge"
        data-testid="comments-outstanding-count"
      >
        {{ outstandingCount }} Outstanding
      </span>
    }
    <span class="comments-card__spacer"></span>
    @if (!readOnly) {
      <button
        type="button"
        class="btn btn--secondary comments-card__ask"
        (click)="toggleAskQuestion()"
        data-testid="comments-ask-question"
      >
        Ask a Question
      </button>
    }
  </div>

  @if (!readOnly && askingQuestion) {
    <div class="comments-card__composer" data-testid="comments-new-question">
      <label class="form-label" for="comments-new-question-input">Your question</label>
      <textarea
        id="comments-new-question-input"
        class="input comments-card__reply-input"
        rows="2"
        [maxlength]="maxLength"
        placeholder="Ask the review team a question..."
        [(ngModel)]="newQuestionDraft"
        data-testid="comments-new-question-input"
      ></textarea>
      <div class="comments-card__composer-footer">
        <span class="comments-card__counter">{{ newQuestionDraft.length }}/{{ maxLength }}</span>
        <div class="comments-card__composer-actions">
          <button
            type="button"
            class="btn btn--primary"
            [disabled]="!canCreateQuestion() || creatingQuestion"
            (click)="createQuestion()"
            data-testid="comments-new-question-send"
          >
            {{ creatingQuestion ? "Sending..." : "Send Question" }}
          </button>
          <button
            type="button"
            class="btn btn--secondary"
            [disabled]="creatingQuestion"
            (click)="cancelQuestion()"
            data-testid="comments-new-question-cancel"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  }

  @if (!threads.length) {
    <div class="empty-state" data-testid="comments-empty">No comments yet</div>
  } @else {
    <ul class="comments-card__threads">
      @for (thread of threads; track thread.id) {
        <li
          class="comments-card__thread"
          [class.comments-card__thread--question]="isQuestion(thread)"
          [class.comments-card__thread--revision]="!isQuestion(thread)"
          [attr.data-testid]="'thread-' + thread.id"
        >
          <div
            class="comments-card__thread-header"
            role="button"
            tabindex="0"
            [attr.aria-expanded]="isThreadExpanded(thread)"
            (click)="toggleThreadExpanded(thread)"
            (keydown.enter)="toggleThreadExpanded(thread)"
            (keydown.space)="$event.preventDefault(); toggleThreadExpanded(thread)"
            [attr.data-testid]="'thread-' + thread.id + '-header'"
          >
            <span
              [class]="typeBadgeClass(thread)"
              [attr.data-testid]="'thread-' + thread.id + '-type'"
            >
              {{ typeLabel(thread) }}
            </span>
            <app-status-pill
              [status]="pillStatus(thread)"
              [testid]="'thread-' + thread.id + '-status'"
            ></app-status-pill>
            <span class="comments-card__spacer"></span>
            @if (thread.createdDate) {
              <span class="comments-card__date">{{ thread.createdDate | date : "MMM d" }}</span>
            }
            <span
              class="comments-card__chevron"
              [class.comments-card__chevron--expanded]="isThreadExpanded(thread)"
              aria-hidden="true"
            >&#9662;</span>
          </div>

          @if (isThreadExpanded(thread)) {
            <ul class="comments-card__messages">
              @for (message of thread.messages; track $index) {
                <li
                  class="comments-card__message"
                  [class.comments-card__message--you]="isVendorMessage(message)"
                >
                  <span class="comments-card__message-meta">
                    {{ messageAuthor(thread, message) }}
                    &middot; {{ message.date | date : "MM/dd/yyyy h:mm a" }}
                  </span>
                  <p class="comments-card__message-body">{{ message.body }}</p>
                </li>
              }
            </ul>

            @if (isOutstanding(thread) && !readOnly) {
              <div class="comments-card__reply">
                <label class="form-label" [attr.for]="'thread-' + thread.id + '-reply'">Reply</label>
                <textarea
                  [id]="'thread-' + thread.id + '-reply'"
                  class="input comments-card__reply-input"
                  rows="2"
                  [maxlength]="maxLength"
                  placeholder="Reply to the review team..."
                  [(ngModel)]="replyDrafts[thread.id]"
                  [attr.data-testid]="'thread-' + thread.id + '-reply'"
                ></textarea>
                <div class="comments-card__composer-footer">
                  <span class="comments-card__counter">
                    {{ (replyDrafts[thread.id] || "").length }}/{{ maxLength }}
                  </span>
                  <div class="comments-card__reply-actions">
                    @if (canResolve(thread)) {
                      <button
                        type="button"
                        class="btn btn--secondary"
                        [disabled]="resolving[thread.id]"
                        (click)="resolve(thread)"
                        [attr.data-testid]="'thread-' + thread.id + '-resolve'"
                      >
                        {{ resolving[thread.id] ? "Resolving..." : "Mark Resolved" }}
                      </button>
                    }
                    <button
                      type="button"
                      class="btn btn--primary comments-card__send"
                      [disabled]="!canSend(thread) || sending[thread.id]"
                      (click)="send(thread)"
                      [attr.data-testid]="'thread-' + thread.id + '-send'"
                    >
                      {{ sending[thread.id] ? "Sending..." : "Send" }}
                    </button>
                  </div>
                </div>
                @if (!isQuestion(thread)) {
                  <p
                    class="comments-card__note"
                    [attr.data-testid]="'thread-' + thread.id + '-note'"
                  >
                    The review team closes this once the revision is accepted.
                  </p>
                }
              </div>
            } @else if (!isOutstanding(thread)) {
              <p
                class="comments-card__resolved-note"
                [attr.data-testid]="'thread-' + thread.id + '-resolved'"
              >
                &#10003; This thread is resolved.
              </p>
            }
          }
        </li>
      }
    </ul>
  }
</div>
